// composables/deviceinfo.composable.ts
import { reactive, readonly } from 'vue';

const deviceState = reactive({
  isMobile: false,
  isTablet: false,
  width: window.innerWidth
});

function checkDevice() {
  const ua = navigator.userAgent.toLowerCase(); 
  const width = window.innerWidth;
  deviceState.width = width;

  deviceState.isMobile =
    /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua) && width < 1024 ||
    width < 768;

  const isIpad =
    /\b(iPad)\b/.test(ua) ||
    (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);
  const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);

  deviceState.isTablet =
    isIpad || isAndroidTablet || (width >= 768 && width < 1280);
}

// init once
let initialized = false;
export function useDeviceInfo() {
  if (!initialized) {
    initialized = true;
    checkDevice();
    window.addEventListener('resize', checkDevice);
  }

  return readonly(deviceState); // read-only to prevent external mutation
}
